import styled from 'styled-components';


export const AddButtonContainer = styled.div`
@media only screen and (max-width: 576px) {
    margin-top: 30px
}
`